import React, { useEffect } from 'react';
import { Breadcrumb, Modal, Table } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import OboSowDetailsTableContainer from '../OboSowDetailsTableContainer/oboSowDetailsTableContainer';
import OboWODetailsTableContainer from '../OboWODetailsTableContainer/oboWODetailsTableContainer';

interface OboModalProps {
  visible: boolean;
  onClose: () => void;
  data: any[];
  level :any[];
  filterData: any;
}

const OboModalContainer: React.FC<OboModalProps> = ({ visible, onClose, data , level ,filterData}) => {
  
  const [breadcrumblist, setBreadcrumbList] = React.useState<any[]>([]);
  const [level_data, setLevel_Data] = React.useState<any[]>([]);
  const [_filterData, setFilterData] = React.useState<any>(filterData);


  useEffect(() => {
    if(level.length>0 && visible===true){
      setLevel_Data(level);
    }
  }, [level]);

  useEffect(() => {
    if(level_data.length>0 && visible===true){
      generatebreadCrumbData(level_data);
    }
  }, [level_data]);

 useEffect(() => {
    if(filterData.dateRange_start && filterData.dateRange_end && visible===true){
      setFilterData(filterData);
    }
  }, [filterData]);

  const getLabel = (item:any) => {

    if(item.levelName === "ParentOpps") {
      return `Opp - ${item.levelData.opportunityID}`;
    }
    else if(item.levelName === "ChildOpps") {
      return `Child Opp - ${item.levelData.opportunityID}`;
    }
    else if(item.levelName === "SOW") {
      return `SOW - ${item.levelData.sowid}`;
    }
  }

  const generatebreadCrumbData=(level:any)=>{
    let temp = level.map((item:any) => {
      return {
        label: getLabel(item),
        key: item.labelName,
      };
    });

    setBreadcrumbList(temp||[]);
  }
  const handleWorkOrderDetails = (data:any, level:any) => {
    setLevel_Data([...level_data,level]);
  }

  const handleBackArrow = () => {
    let temp = [...level_data];
    if(temp.length==2 && temp[1].levelName==="ChildOpps"){
      temp.pop();
    }

    temp.pop();
    setLevel_Data(temp);

    if(temp.length==0){
      onClose();
    }
  }
  return (
    <Modal
      // title="OBO Details"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={1350} 
      destroyOnClose={true}
      maskClosable={false}
      styles={{
        content: {
          borderRadius: '0',
          borderTop: '4px solid #1677ff',
          font: 'normal normal normal 14px/20px Nunito Sans',
        },
      }}
    >
      <div style={{display:'flex', alignItems: 'center', padding:'10px 0px', marginBottom:'10px'}}>
        <ArrowLeftOutlined  style={{marginRight:'10px', cursor:'pointer'}} onClick={()=>handleBackArrow()}/>
        <Breadcrumb
        className='header-obo'>
        {breadcrumblist.map((item) => (
          <Breadcrumb.Item key={item.key}  >{item.label}</Breadcrumb.Item>
        ))}
      </Breadcrumb>
      </div>

      {level_data.length>0 && (level_data[level_data.length-1].levelName==="ParentOpps"||level_data[level_data.length-1].levelName==="ChildOpps" ) && 
      <OboSowDetailsTableContainer parentOpp={level_data[level_data.length-1].levelData} filterData={_filterData} fetchWorkOrderDetails= {handleWorkOrderDetails} />}

      {level_data.length>0 && level_data[level_data.length-1].levelName==="SOW"&& 
      <OboWODetailsTableContainer parentSOW={level_data[level_data.length-1].levelData} />}
    </Modal>
  );
};

export default OboModalContainer;